import React, {
  useState,
  useMemo,
  useEffect,
  createContext,
  useContext,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Form, useFormContext } from "../Form";
import api from "src/config/api";
import eventBus from "src/common/eventBus";
import _ from "lodash";

const TableContext = createContext(null);

export const useTableContext = () => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};

export const TableProvider = forwardRef(
  ({ defaultFiter = {}, ...props }, ref) => {
    return (
      <Form
        direction="vertical"
        layout="vertical"
        defaultValues={{page: 1, limit: 10, ...defaultFiter}}
        onSubmit={() => {}}
      >
        <Table ref={ref} {...props} />
      </Form>
    );
  }
);

const Table = forwardRef(
  (
    {
      url,
      children,
    },
    ref
  ) => {
    const { getValues } = useFormContext();
    const [data, setData] = useState([]);
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(url, {
          params: _.pickBy(getValues(), _.identity),
        });
        setData(response.data.data);
        setMetadata(response.data.metadata);
      } catch (error) {
        eventBus.emit("dialog", {
          type: "error",
          message: error.response?.data?.message || "Error fetching Data",
        });
      } finally {
        setLoading(false)
      }
    };

    useEffect(() => {
      fetchData();
    }, []);

    useImperativeHandle(ref, () => ({
      refresh: fetchData,
    }));

    const contextValue = {
      data,
      metadata,
      fetchData,
      loading,
      setMetadata
    };

    return (
      <TableContext.Provider value={contextValue}>
          {children}
      </TableContext.Provider>
    );
  }
);

// TableProvider.propTypes = {
//   columns: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//       sortable: PropTypes.bool,
//       render: PropTypes.func,
//       width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     })
//   ).isRequired,
//   data: PropTypes.array.isRequired,
//   selectable: PropTypes.bool,
//   actions: PropTypes.arrayOf(
//     PropTypes.shape({
//       label: PropTypes.string.isRequired,
//       icon: PropTypes.node,
//       onClick: PropTypes.func.isRequired,
//     })
//   ),
//   filterInputs: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//       type: PropTypes.oneOf(["text", "select", "date"]).isRequired,
//       options: PropTypes.arrayOf(
//         PropTypes.shape({
//           value: PropTypes.string.isRequired,
//           label: PropTypes.string.isRequired,
//         })
//       ),
//     })
//   ),
//   moreFilters: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//       type: PropTypes.oneOf(["text", "select", "date"]).isRequired,
//       options: PropTypes.arrayOf(
//         PropTypes.shape({
//           value: PropTypes.string.isRequired,
//           label: PropTypes.string.isRequired,
//         })
//       ),
//     })
//   ),
//   onFilterChange: PropTypes.func,
//   onSelectionChange: PropTypes.func,
// };

export default TableProvider;
